<template>
    <v-container class="container">
        <v-row>
            <v-col class="pl-0 mb-3">
                <h2 class="mb-2">Fakulty a součásti</h2>
                <div class="subtitle">Vyberte fakultu nebo součást, pro kterou chcete spravovat informační panel</div>
            </v-col>
        </v-row>
        <Loading v-if="!didLoadAdministrators" class="mt-12"/>
        <v-row v-else-if="units.length !== 0">
            <v-col 
                v-for="unit in units"
                :key="unit.name"
                cols="12"
                md="6"
                lg="4"
                class="mb-5"
            >
                <v-card
                    variant="outlined"
                    @click="pushToDetail(unit.id)"
                    class="mr-5 mb-5"
                    style="border: 2px solid #eeeeef"
                >
                    <v-list-item three-line>
                        <v-list-item-content>
                            <v-img
                                :src="controlIcon(unit.imageUrl)"
                                height="30"
                                width="30"
                                contain
                            />
                            <v-list-item-title class="titleCard mb-2">
                                {{ unit.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="subTitleCard">
                                {{ unit.description }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-actions>
                        <v-btn color="primary" text>Vstoupit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                <PlaceHolder 
                    :path="'/icons/faculties-place-holder.png'"
                    text="Je nám líto, momentálně nemáte priřazená práva k žádným součastem."
                    title="Žádná práva k součástem"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'; 
import { computed, onMounted } from 'vue';
import PlaceHolder from "@/components/news/PlaceHolder";
import Loading from "@/components/Loading";

export default {
    name: "Units",

    components: {
        Loading,
        PlaceHolder
    },

    setup() {
        const store = useStore();
        const router = useRouter(); 

        const didLoadAdministrators = computed(() => store.getters['displaysAdmins/didLoadAdministrators']);
        const getAdministrators = computed(() => store.getters['displaysAdmins/getAdministrators']);
        const username = computed(() => store.getters['user/username']);
        
        const currentUser = computed(() => getAdministrators.value.find(user => user.xlogin === username.value));
        
        const units = computed(() => {
            return (currentUser.value?.faculties || []).map(faculty => ({
                id: faculty.id,
                name: faculty.localizedAttributes.cz.name,
                description: faculty.localizedAttributes.cz.description,
                imageUrl: faculty.imageUrl
            }));
        });

        const fetchAdministrators = () => {
            return store.dispatch('displaysAdmins/fetchAdministrators');
        };

        const controlIcon = (icon) => {
            return icon ? icon : '/icons/mendelu.png';
        };

        const pushToDetail = (unitId) => {
            router.push({ name: 'unitDetail', params: { unitId } });
        };

        onMounted(async () => {
            await fetchAdministrators();
        });

        return {
            didLoadAdministrators,
            units,
            controlIcon,
            pushToDetail
        };
    }
}
</script>

<style scoped>
.button {
    color: #78BE13;
    font-weight: bold;
    font-size: 16px;
}

.titleCard {
    padding-left: 0;
    padding-top: 0;
    font-weight: 500;
    line-height: 1.2;
    word-break: normal;
    font-size: 20px;
}

.subTitleCard {
    padding: 0;
    font-size: 14px;
    line-height: 1.2;
}

.card {
    height: 130px;
}

.container {
    padding-bottom: 250px;
}

.subtitle {
    font-size: 16px;
    color: #6D7278;
}
</style>
